module.exports = __webpack_public_path__ + "static/media/inside_seats.fef8fb8e.jpeg";